module.exports = __webpack_public_path__ + "img/chat1.8ac25871.png";